import LoopAnimationModal from "../../Component/Elements/LoopAnimationModal/LoopAnimationModal";
import CSS from "./static/css/photoDetail.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import usePhotoDetailDataSetter from "./hooks/usePhotoDetailDataSetter.hook";
import { useEffect, useMemo } from "react";
import { customParseInt, dev_console, getAccountData, isAbleAccesser } from "../../Common/ts/commonTools";
import PhotoInfoContainerSet from "./components/PhotoInfoContainerSet/PhotoInfoContainerSet";
import BottomSheetOpenButton from "../../Component/Elements/BottomSheetOpenButton/BottomSheetOpenButton";
import Overlay from "../../Component/Elements/Overlay/Overlay";
import EventButtonSet from "./components/EventButtonSet/EventButtonSet";
import usePhotoDetailDataREST from "./hooks/usePhotoDetailDataREST.hook";
import ThreeSplitPages from "../../Component/Elements/Page/ThreeSplitPages/ThreeSplitPages";
import UploadImageListViewMode from "../../Component/Elements/UploadImageListViewMode/UploadImageListViewMode";
import PhotoInfoCard from "./components/PhotoInfoCard/PhotoInfoCard";
import { photoDetailsTypeCodeType, photoTypeCodeType } from "./static/interface/const.interface";
import { getCodeQueryParams } from "../../Common/ts/appTools";
import { PHOTO_DETAILS_TYPE_CODE, PHOTO_TYPE_CODE } from "./static/ts/const";
import useProductListREST from "../ProductManufacturing/hooks/REST/useProductListREST";
import { PRODUCT_LIST_FILTER_CODE_OBJ } from "../ProductManufacturing/static/ts/const";
import { useCommonStore } from "../../App";
import useHistoryBackContralOverlayState from "../../Component/Elements/Overlay/hooks/useHistoryBackContralOverlayState.hook";
import useIsMobile from "../../Common/hooks/useIsMobile";
import usePhotoImageDataListREST from "../ProductManufacturing/hooks/REST/usePhotoImageDataListREST";
import { FILE_USAGE_CD, FileUsageCd_Type } from "../ProductManufacturing/static/interface/ProductItemPhoto.interface";
import { fileCodeType } from "../../Common/interface/Common.interface";
import { FILE_CODE } from "../../Common/ts/const";
import { uploadImageListViewMode_folderInfo_Interface } from "../../Component/Elements/UploadImageListViewMode/static/interface/UploadImageListViewMode.interface";
import { viewerImageInterface } from "../../Component/Elements/ImageGallery/interface/ImageGallery.interface";
import ImageZipDownloadIcon from "../../Component/Elements/ImageZipDownload/ImageZipDownloadIcon";
import useFileInfoListStore, { FileInfoListStore_Type } from "./hooks/useFileInfoListStore.store";
import SelectImageVersion from "./components/SelectImageVersion/SelectImageVersion";
import CardContainer from "@/Component/Elements/CardContainer/CardContainer";
import Button from "@/Component/Elements/Button/Normal/Button";

const PhotoDetail = () => {
    const navigate = useNavigate();
    const {
        isOpen,
        openOverlay,
        closeOverlay
    } = useHistoryBackContralOverlayState(false);

    const [URLSearchParams, SetURLSearchParams] = useSearchParams();

    // 이미지 데이터 관리 store
    const {
        fileInfoList,
        setFileInfoList,
        clearFileInfoList,
        selected_index,
        setIsDisabled,
    } = useFileInfoListStore();

    const setHeaderRightNode = useCommonStore((state) => state.setHeaderRightNode);

    const isMobile = useIsMobile();

    const l_brand_id = getAccountData.brand_id();

    // 사용되는 값이 정해져있으므로 해당 부분을 검증하는 getQueryParams함수를 사용해 값을 처리한다.
    let l_photo_type = getCodeQueryParams<photoTypeCodeType>(URLSearchParams.get("photo_type"), PHOTO_TYPE_CODE);

    // 사용되는 값이 정해져있으므로 해당 부분을 검증하는 getQueryParams함수를 사용해 값을 처리한다.
    let l_viewRange_type = getCodeQueryParams<photoDetailsTypeCodeType>(URLSearchParams.get("viewRange_type"), PHOTO_DETAILS_TYPE_CODE);

    let l_schedule_id: number | null = null;
    if(URLSearchParams.get("schedule_id")){
        l_schedule_id = customParseInt(URLSearchParams.get("schedule_id"));
    }

    // 필요한 정보가 넘어오지 않았다면, 되돌려보낸다.
    if(l_photo_type === null || l_viewRange_type === null || l_schedule_id === null){
        // useNavigate로 넘기지 않는 이유?
        // navigate로 넘기려고 시도했을때는 이 조건문이 감지된 후에도 코드의 끝까지 동작이 진행되서 발생하는 하위단계의 에러로 인해 코드의 동작 자체가 중단되는 문제가 있었다.
        // 이를 해결하고자 현재 코드로 처리하였다.

        // window.location.href = "/photoList";



        //
        // param 유효하지 않을때 redirect 하지 않고 에러메시지만 보여주도록 처리. 뒤로가기 문제 개선 (Bruce.Cheong 2026-05-14)
        // 기존 코드구조를 유지하기 위해 부득이 하게 여기에 return문을 추가함.
        //
        const isAbleHistoryBack = ( (typeof window !== "undefined") && (window.history.length > 1) );

        return (
            <CardContainer
                class_name_list={[CSS.l_photo_detail_empty_page]}
                noStyle={true}
            >
                <div className={CSS.l_photo_detail_empty_card}>
                    <strong className={CSS.l_photo_detail_empty_title}>
                        등록된 사진이 없습니다.
                    </strong>

                    <Button
                        class_name_list={[CSS.l_photo_detail_empty_action_button]}
                        onClick={() => {
                            if(isAbleHistoryBack){
                                navigate(-1);
                            }else{
                                navigate("/", { replace: true });
                            }
                        }}
                    >
                        {isAbleHistoryBack ? "이전페이지" : "홈으로"}
                    </Button>
                </div>
            </CardContainer>
        );
    }

    // 검증이 끝난 값의 타입을 확정시켜준다.
    l_photo_type = l_photo_type as photoTypeCodeType;
    l_viewRange_type = l_viewRange_type as photoDetailsTypeCodeType;
    l_schedule_id = l_schedule_id as number;

    let l_file_usage_cd: FileUsageCd_Type | undefined = undefined;

    switch(l_photo_type){
        case PHOTO_TYPE_CODE.contract_shoot:
            l_file_usage_cd = FILE_USAGE_CD.ORIGINAL_PHOTO;
            break;
        case PHOTO_TYPE_CODE.event_shoot:
            l_file_usage_cd = FILE_USAGE_CD.REVIEW_EVENT_PHOTO;
            break;
        default:
            break;
    }

    const {
        photoDetailData,
        photoDetailDataIsLoading,
    } = usePhotoDetailDataREST({
        schedule_id: l_schedule_id || 0,
        main_type: l_photo_type,
    })

    // 2026.01.22 - 김효민 - 신규 사진데이터 요청 엔드포인트
    // upload_file_pk 목록을 확보하기 위한 요청
    const {
        photoImageDataListData,
    } = usePhotoImageDataListREST({
        brand_id: l_brand_id,
        data_pk: l_schedule_id || 0,
        file_usage_cd: l_file_usage_cd as FileUsageCd_Type,
        order_by: 2,
        get_fields: [], // 이미지데이터는 당장 필요 없으므로 제거한다.
    })

    // 실제 이미지 데이터 호출
    const {
        photoImageDataListData: selectedPhotoImageDataListData,
        photoImageDataListIsLoading: selectedPhotoImageDataListIsLoading,
    } = usePhotoImageDataListREST({
        brand_id: l_brand_id,
        data_pk: l_schedule_id || 0,
        upload_file_pk: fileInfoList[selected_index]?.upload_file_pk || 0,
        file_usage_cd: l_file_usage_cd as FileUsageCd_Type,
    })

    // 파일 타입을 추출하는 함수
    function getFileType(type: string){
        let RTN: fileCodeType = FILE_CODE.none;

        // 서버에서 소문자로 줄수도 대문자로 줄 수도 있어서 소문자로 통일시키는 작업을 거친다
        const m_photo_list_item_file_type = type.toLowerCase();
        switch(m_photo_list_item_file_type){
            case "jpg":
                RTN = FILE_CODE.img;
                break;
            case "mp4":
                RTN = FILE_CODE.video;
                break;
            case "zip":
                RTN = FILE_CODE.zip;
                break;
            default:
                RTN = FILE_CODE.none;
        }

        return RTN;
    }

    // yyyyMMddHHmmss 형식의 문자열을 각 단위별로 추출하는 함수
    function transformDatefromyyyyMMddHHmmss(dateString: string){
        // 1. 문자열을 각 단위별로 추출 (substring 활용)
        const year = dateString.substring(0, 4);
        const month = dateString.substring(4, 6);
        const day = dateString.substring(6, 8);
        const hour = dateString.substring(8, 10);
        const minute = dateString.substring(10, 12);
        const second = dateString.substring(12, 14);

        return {
            year,
            month,
            day,
            hour,
            minute,
            second,
        }
    }

    // // 폴더구조로 데이터 변환
    const photoImageDataList: uploadImageListViewMode_folderInfo_Interface[] = useMemo(() => {
        const RTN: uploadImageListViewMode_folderInfo_Interface[] = [];

        if(selectedPhotoImageDataListData && selectedPhotoImageDataListData.data.length > 0){
            const imageFileList: viewerImageInterface[] = selectedPhotoImageDataListData.data[0].upload_file_detail_data.map((item) => {
                return {
                    thumbnail_url: item.small_img,
                    middle_img_url: item.middle_img,
                    origin_url: item.org_img,
                    file_type: getFileType(item.file_ext),
                    file_name: item.file_nm,
                    folder_id: customParseInt(item.folder_id) || 0,
                }
            })

            RTN.push({
                folder_name: "",
                folder_id: 0,
                middle_img_url: "",
                small_img_url: "",
                img_list: imageFileList,
            })
        }

        return RTN;
    }, [selectedPhotoImageDataListData])

    const {
        common_data,
        downloadIcon_data,
        uploadImageListViewMode_data,
        photoInfoCard_data,
        eventButtonSet_data,
        shoot_data,
    } = usePhotoDetailDataSetter({
        photoDetailData,
        location_state_data: {
            photo_type: l_photo_type,
            viewRange_type: l_viewRange_type as photoDetailsTypeCodeType,
        }
    })

    // 신청해야할 제품이 있는 경우에만 버튼을 노출하기 위해...
    // 구조상 너무 과하다다고 판단되면 개선하긴 해야할듯...
    // 그래도 캐싱은 되니까... 괜찮지 않을까???
    const {
        productListData,
    } = useProductListREST({
        search_type: PRODUCT_LIST_FILTER_CODE_OBJ.need_to_request
    })

    useEffect(() => {
        isAbleAccesser({
            allowedUserTypeList: ["C"],
        });
    }, [])

    useEffect(() => {
        if(fileInfoList[selected_index]?.is_can_download){
            setHeaderRightNode(
                <ImageZipDownloadIcon
                    brand_id={l_brand_id}
                    upload_file_pk={selectedPhotoImageDataListData?.data[0]?.upload_file_pk || 0}
                    file_name={downloadIcon_data.fileName}
                    file_size={selectedPhotoImageDataListData?.data[0]?.upload_file_size || 0}
                    isHidden={"web"}
                />
            )
        }else{
            setHeaderRightNode(<></>);
        }
    }, [downloadIcon_data, selectedPhotoImageDataListData, selected_index, fileInfoList])

    // 업로드 파일 데이터를 스토어에 저장
    useEffect(() => {
        if(photoImageDataListData && photoImageDataListData.data.length > 0){
            const fileDataList: FileInfoListStore_Type[] = [];

            photoImageDataListData.data.forEach((item) => {
                const uploadDate_temp = transformDatefromyyyyMMddHHmmss(item.upload_file_ts);
                const uploadDate = `${uploadDate_temp.year}-${uploadDate_temp.month}-${uploadDate_temp.day}`;

                fileDataList.push({
                    upload_date: uploadDate,
                    upload_file_pk: item.upload_file_pk,
                    is_can_download: item.org_delete_dtm ? false : true, // 값이 존재하지 않아야 다운로드가 가능하다.
                })
            })

            setFileInfoList(fileDataList);
        }else{
            clearFileInfoList();
        }
    }, [photoImageDataListData])

    // 이미지 데이터를 불러오는 동안에 라디오 버튼 잠금을 위해 처리
    useEffect(() => {
        setIsDisabled(selectedPhotoImageDataListIsLoading);
    }, [selectedPhotoImageDataListIsLoading])

    return (
        <ThreeSplitPages
            title={common_data.pageTitle}

            centerContainerNode={
                <UploadImageListViewMode
                    folderInfoList={photoImageDataList}
                    isSingle={uploadImageListViewMode_data.isSingle}
                    thumbnail_no_padding={true}
                />
            }

            isRightHidden={"mobile"}
            rightContainerNode={
                <div className={CSS.l_right_wrap}>
                    <PhotoInfoContainerSet
                        shoot_data={shoot_data}

                        isPrintDownloadBtn={fileInfoList[selected_index]?.is_can_download}
                        upload_date={photoInfoCard_data.uploadDate}
                        brand_id={l_brand_id}
                        upload_file_pk={fileInfoList[selected_index]?.upload_file_pk || 0}

                        // [isEventApplication 제거 - 2026-05-06 khm] 전달만 하던 props
                        // isEventApplication={photoInfoCard_data.isEventApplication}
                        isPrintProductRequestBtn={productListData.length > 0 && photoInfoCard_data.isPrintProductRequestBtn}
                        scheduleId={photoInfoCard_data.scheduleId}
                        joined_event={photoInfoCard_data.joinedEvent}
                    />
                </div>
            }

            bottomContainerNode={
                <>
                    {/* 모바일 화면 사이즈에서 상세정보보기 버튼 */}
                    <BottomSheetOpenButton
                        title={"상세 정보 보기"}
                        onClick={openOverlay}
                        isHidden={"web"}
                    />

                    {
                        isMobile
                        &&  <EventButtonSet
                                // [isEventApplication 제거 - 2026-05-06 khm] 전달만 하던 props
                                // isEventApplication={eventButtonSet_data.isEventApplication}
                                isPrintProductRequestBtn={productListData.length > 0 && eventButtonSet_data.isPrintProductRequestBtn}
                                scheduleId={eventButtonSet_data.scheduleId}
                                upload_date={eventButtonSet_data.uploadDate}
                                joined_event={eventButtonSet_data.joinedEvent}
                            />
                    }

                    <Overlay
                        isOverlayOpen={isOpen}
                        overlayCloseHandler={closeOverlay}
                    >
                        {/* PhotoInfoContainerSet안에 PhotoInfoCard가 있으니까... 사실상 같은 컴포넌트를 쓰고 있다고 볼 수 있겠지? */}
                        <div className={CSS.l_overlay_container}>
                            <SelectImageVersion />

                            <PhotoInfoCard
                                shoot_data={shoot_data}
                            />

                            <EventButtonSet
                                // [isEventApplication 제거 - 2026-05-06 khm] 전달만 하던 props
                                // isEventApplication={eventButtonSet_data.isEventApplication}
                                isPrintProductRequestBtn={productListData.length > 0 && eventButtonSet_data.isPrintProductRequestBtn}
                                scheduleId={eventButtonSet_data.scheduleId}
                                upload_date={eventButtonSet_data.uploadDate}
                                joined_event={eventButtonSet_data.joinedEvent}
                            />
                        </div>
                    </Overlay>

                    {/* 로딩상태 처리 모달 */}
                    <LoopAnimationModal
                        isModalOpen={photoDetailDataIsLoading}
                    />
                </>
            }
        />
    )
}

export default PhotoDetail
